import { gql } from '@apollo/client';

import { AcademyActivityByMonth } from '@ts-core/modules/billing/types';

export interface GetAcademyActivityByMonthQueryVariables {
  year: string;
  month: string;
}

export interface GetAcademyActivityByMonthQueryResult {
  academyActivity: AcademyActivityByMonth;
}

export const getAcademyActivityByMonthQuery = gql`
  query GetAcademyActivityByMonth($year: String!, $month: String!) {
    academyActivity(year: $year, month: $month) @rest(type: "GetAcademyActivityByMonth", path: "students-activity/overview?{args}") {
      courses
      academy
      coursesCount
      studentsCount
      year
      month
      mediaSessionsCount
      assignmentAnswersCount
      practiceSessionsCount
      activityAnswersCount
      documentsCount
      totalCost
    }
  }
`;
